import { configureApi } from '@provisium/web-api'

configureApi({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? 'https://api.provisium.ru/api/v1',
})

export {
  ApiError,
  apiRequest,
  apiUpload,
  configureApi,
  getAccessToken,
  setAccessToken,
  setTokenRefreshHandler,
} from '@provisium/web-api'
